import {Bars} from 'react-loader-spinner'
import axios from "axios";
import moment from "moment";
import React, {useContext, useEffect, useState} from "react";
import Chart from "../../Chart/Chart";
import {authContext} from "../../Context/Authentication/authContext";
import {generateMonthCount} from "../../util";
import "./DaysOnMarket.scss";
import {baseURL} from '../../config';
import {getZipcodes} from './helpers'
import { getAdjustedPredictionData, getAdjustedSentimentData} from '../../Helpers/helpers'
import WChart from '../../WhatIfAnalysis/Chart/Chart';

const PredctionDaysOnMarket = () => {
    const {state}: any = useContext(authContext);
    const [chartData, setChartData]: any = useState(null);
    const [isAdjustedPrediction, setIsAdjustedPrediction]: any = useState(false);
    useEffect(() => {
        setChartData(null);
        if (state.filters.predictionsArray.length != 0) {
            setIsAdjustedPrediction(true);
            getAllPredictionData()
          }
       else {
            setIsAdjustedPrediction(false)
            if (state.filters.showInterval && state.filters.zipcodePrediction?.length === 0) {
                getDaysOnMarketByInterval();
            } else if (state.filters.zipcodePrediction?.length && state.filters.showInterval) {
                getDaysOnMarketZipcodeByInterval(getZipcodes(state?.filters?.zipcodePrediction));
            } else {
                getDaysOnMarketByZip(getZipcodes(state?.filters?.zipcodePrediction));
            }
        }

    }, [
        state.filters.years,
        state.filters.city,
        state.filters.value,
        state.filters.showInterval,
        state?.filters?.selectedType,
        state?.filters?.regionType,
        state?.filters?.neighborhood,
        state?.filters?.zipcodePrediction,
        state.filters.refreshAdjustedPredictionSubmit ,
        state.filters.refreshAdjustedSentimentSubmitByConsumer,
        state.filters.refreshAdjustedSentimentSubmitByBuilder
    ]);

    const getAllPredictionData=()=>{
        if (state.filters.predictionsArray.length != 0) {
          let mainarr: any = [];
          let res1: any = [];
          let res2: any = [];
          let res3: any = [];
        
          // Create an array of promises for each async callś
          const promises = state.filters.predictionsArray.map(async (t: any) => {
            let zipcodes = getZipcodes(state?.filters?.zipcodePrediction).split(',')
            if (t == "Mortgage Rates") {
               const query = `${state.filters.state}/${zipcodes[0]}/zipcode`
              let data = state.filters.adjustedPredictionValues;
              delete data.status;
              res1 = await getAdjustedPredictionData(query, data, "dom");
              console.log(res1, 'resp1');
            } else if (t == "Consumer Sentiments(HPSI)") {
              let type = 'consumer';
               const query = `${state.filters.state}/${zipcodes[0]}/zipcode`
              let data =
                type === "consumer"
                  ? state.filters.adjustedSentimentValuesByConsumer
                  : state.filters.adjustedSentimentValuesByBuilder;
              delete data.status;
              res2 = await getAdjustedSentimentData(query, data, `dom/${type}`);
              console.log(res2, 'resp2');
            } else if (t == "Builder Sentiments(NAHB)") {
              let type = 'builder';
               const query = `${state.filters.state}/${zipcodes[0]}/zipcode`
              let data =
                type === "consumer"
                  ? state.filters.adjustedSentimentValuesByConsumer
                  : state.filters.adjustedSentimentValuesByBuilder;
              delete data.status;
              res3 = await getAdjustedSentimentData(query, data, `dom/${type}`);
              console.log(res3, 'resp3');
            }
          });
        
          // Wait for all promises to resolve
          Promise.all(promises)
            .then(() => {
              if(res1.length>0){
                res1.forEach((item: any, index: any) => {
                  mainarr.push({
                    date: item.date,
                    actual_predictions: item.actual_predictions,
                    adjusted_prediction: res1[index]?.adjusted_prediction || "",
                    consumer_adjusted_prediction: res2[index]?.adjusted_prediction || "",
                    builder_adjusted_prediction: res3[index]?.adjusted_prediction || "",
                  });
                });
    
              }
              else if(res2.length>0){
                res2.forEach((item: any, index: any) => {
                  mainarr.push({
                    date: item.date,
                    actual_predictions: item.actual_predictions,
                    adjusted_prediction: res1[index]?.adjusted_prediction || "",
                    consumer_adjusted_prediction: res2[index]?.adjusted_prediction || "",
                    builder_adjusted_prediction: res3[index]?.adjusted_prediction || "",
                  });
                });
    
              }
              else if(res3.length>0){
                res3.forEach((item: any, index: any) => {
                  mainarr.push({
                    date: item.date,
                    actual_predictions: item.actual_predictions,
                    adjusted_prediction: res1[index]?.adjusted_prediction || "",
                    consumer_adjusted_prediction: res2[index]?.adjusted_prediction || "",
                    builder_adjusted_prediction: res3[index]?.adjusted_prediction || "",
                  });
                });
    
              }
    
              console.log(mainarr);
              setChartData(mainarr)
            })
            .catch((error) => {
              console.error('Error occurred:', error);
            });
        }
        
    
      }


    // useEffect(() => {
    //     setChartData(null);
    //     if (state.filters.refreshAdjustedPredictionSubmit  && state.filters.zipcodePrediction?.length > 0) {
    //         setIsAdjustedPrediction(true)
    //         getAdjustedPrediction()
    //     } 
    //     else if (state.filters.refreshAdjustedSentimentSubmitByConsumer  && state.filters.zipcode?.length === 0) {
    //         console.log('jkplll')
    //         setIsAdjustedPrediction(true)
    //         getAdjustedSentiment('consumer')
    //       } 
    //       else if (state.filters.refreshAdjustedSentimentSubmitByBuilder  && state.filters.zipcode?.length === 0) {
    //         console.log('jkp')
    //         setIsAdjustedPrediction(true)
    //         getAdjustedSentiment('builder')
    //       } else {
    //         setIsAdjustedPrediction(false)
    //         if (state.filters.showInterval && state.filters.zipcodePrediction?.length === 0) {
    //             getDaysOnMarketByInterval();
    //         } else if (state.filters.zipcodePrediction?.length && state.filters.showInterval) {
    //             getDaysOnMarketZipcodeByInterval(getZipcodes(state?.filters?.zipcodePrediction));
    //         } else {
    //             getDaysOnMarketByZip(getZipcodes(state?.filters?.zipcodePrediction));
    //         }
    //     }

    // }, [
    //     state.filters.years,
    //     state.filters.city,
    //     state.filters.value,
    //     state.filters.showInterval,
    //     state?.filters?.selectedType,
    //     state?.filters?.regionType,
    //     state?.filters?.neighborhood,
    //     state?.filters?.zipcodePrediction,
    //     state.filters.refreshAdjustedPredictionSubmit ,
    //     state.filters.refreshAdjustedSentimentSubmitByConsumer,
    //     state.filters.refreshAdjustedSentimentSubmitByBuilder
    // ]);

    const getAdjustedPrediction = async () => {
        let zipcodes = getZipcodes(state?.filters?.zipcodePrediction).split(',')
        const query = `${state.filters.state}/${zipcodes[0]}/zipcode`
        let data = state.filters.adjustedPredictionValues
        delete data.status
        const resp = await getAdjustedPredictionData(query, data, 'dom')
        setChartData(resp)
    }
    
  const getAdjustedSentiment = async (type:string) => {
    let zipcodes = getZipcodes(state?.filters?.zipcodePrediction).split(',')
    const query = `${state.filters.state}/${zipcodes[0]}/zipcode`
    let data = type ==='consumer'?state.filters.adjustedSentimentValuesByConsumer:state.filters.adjustedSentimentValuesByBuilder
    delete data.status
    const resp = await getAdjustedSentimentData(query, data, `dom/${type}`)
    
    setChartData(resp)
  }


    const getDaysOnMarketByZip = async (zipcodeData: any) => {
        const start = state.filters.years[0];
        const end = state.filters.years[1];
        try {
            const response = await axios.get(
                `${baseURL}getDaysOnMarketZipcode?state=${state.filters.state}&zipcode=${zipcodeData}&startYear=${start}&endYear=${end}&flag=${state.filters.value.toLowerCase()}`
            );
            const data = generateZipChartData(response.data?.cube);
            setChartData(data);
        } catch (error) {
            console.log("error", error);
        }
    };

    const getDaysOnMarketZipcodeByInterval = async (zipcodeData: any) => {
        const start = state.filters.years[0];
        const end = state.filters.years[1];
        try {
            const response = await axios.get(
                `${baseURL}getDaysOnMarketZipcodeInterval?state=${state.filters.state}&zipcode=${zipcodeData}&startYear=${start}&endYear=${end}&flag=${state.filters.value.toLowerCase()}`
            );
            const data = generateIntervalChartData(response.data?.cube);
            setChartData(data);
        } catch (error) {
            console.log("error", error);
        }
    };

    const getDaysOnMarketByInterval = async () => {
      const city = JSON.stringify(state.filters.city)
      .replace(/^\[|\]$/g, "") // Only removes the starting and ending square brackets
      .replaceAll('"', "'");
        const start = state.filters.years[0];
        const end = state.filters.years[1];
        try {
            const response = await axios.get(
                `${baseURL}getDaysOnMarketInterval?state=${state.filters.state}&city=${city}&startYear=${start}&endYear=${end}&flag=${state.filters.value.toLowerCase()}`
            );
            const data = generateIntervalChartData(response.data?.cube);
            setChartData(data);
        } catch (error) {
            console.log("error", error);
        }
    };


    const generateZipChartData = (apiData: any) => {
        try {
            const start = state.filters.years[0];
            const end = state.filters.years[1];
            const totalMonths = generateMonthCount(start, end);
            const data: any = [];
            const rawZipcodes = state?.filters?.zipcodePrediction

            for (let i = 0; i < totalMonths; i++) {
                let value: any = {};
                for (let j = 0; j < rawZipcodes.length; j++) {
                    if (apiData[rawZipcodes[j].split("_")[0]]?.length) {
                        value = {
                            ...value,
                            date: moment(
                                apiData[rawZipcodes[j].split("_")[0]][i]?.date
                            ).format("YYYY-MM-DD"),
                            [`value${j + 1}`]:
                            apiData[rawZipcodes[j].split("_")[0]][i]
                                ?.daysOnMarket,
                        };
                    } else {
                        continue;
                    }
                }
                Object.keys(value)?.length > 0 && data.push(value);
            }
            return data;
        } catch (error) {
            console.log(error);
        }
    };

    const generateIntervalChartData = (apiData: any) => {
        try {
            const data: any = apiData.map((item: any) => {
                return {
                    date: moment(item?.date).format("YYYY-MM-DD"),
                    value1: item?.daysOnMarketHigh,
                    value2: item?.daysOnMarketLow,
                    value3: item?.daysOnMarket,
                };
            });
            return data;
        } catch (error) {
            console.log(error);
        }
    };

    const getSelectValue=()=>{
        switch(state.filters.value){
          case 'Absolute':
            return 'Absolute'
          case 'growth':
              return ' Growth (Month on Month)'
          case 'trend':
                return 'Long Term Trend'
         case 'percentage':
                  return 'Percentage'
          
        }
      }

    return (
        <div className="daysOnMarket-main prediction-chart">
          {chartData?.length && !isAdjustedPrediction ? (
                <div className="daysOnMarket-main__text">Days On Market {getSelectValue()}</div>
            ) : null}
            <div className="daysOnMarket-main__chartContainer">
                {chartData === null ? (
                    <div className="daysOnMarket-main__chartContainer__isLoading">
                        {state?.filters?.zipcodePrediction.length ? <Bars height='400' ariaLabel='bars-loading' wrapperClass='tab-spinner-progress-bar' visible={true}/> : "Select a zipcode to view data"}
                    </div>
                ) : chartData?.length ? (
                  <>
                      {isAdjustedPrediction ? (
                        <WChart
                          chartData={chartData}
                          chartId={'dom-chart'}
                          title='Adjusted DOM Projection  '
                          isMulti
                          isPredition
                          isSetToZoom
                        />
                      ) : (
                        <Chart
                          chartData={chartData}
                          title={`Days on market ${state.filters.value.toLowerCase() === 'growth' ? '(%)': ''}`}
                          city={state.filters.city}
                          zipcode={state?.filters?.zipcodePrediction}
                          showInterval={state.filters.showInterval}
                        />
                      )}
                  </>

                ) : (
                    <div className="daysOnMarket-main__chartContainer__noData">
                        No Data Available
                    </div>
                )}
            </div>
        </div>
    );
};

export default PredctionDaysOnMarket;
